"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tabs = exports.Tab = exports.TabsContext = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const utils_1 = require("@obvio/utils");
const rc_tabs_1 = __importStar(require("rc-tabs"));
const toArray_1 = __importDefault(require("rc-util/lib/Children/toArray"));
const react_1 = require("react");
const lib_1 = require("../Form/lib");
exports.TabsContext = (0, react_1.createContext)(null);
const StyledTabs = (0, app_1.styled)(rc_tabs_1.default) `
  border: none !important;
  display: flex;
  &.rc-tabs-top {
    flex-direction: column;
  }
  .rc-tabs-nav {
    padding-bottom: 2.25rem;
    display: flex;
    flex: none;
    position: relative;
    > .rc-tabs-nav-operations {
      display: none;
    }
    > .rc-tabs-nav-operations-hidden {
      position: absolute;
      visibility: hidden;
      pointer-events: none;
    }
  }
  .rc-tabs-nav > .rc-tabs-nav-wrap {
    transform: translate(0);
    position: relative;
    display: inline-block;
    flex: auto;
    white-space: nowrap;
    overflow: hidden;
    display: flex;
    > .rc-tabs-nav-list {
      display: flex;
      width: 100%;
      justify-content: space-around;
      cursor: pointer;
      border-bottom: 1px ${(theme) => theme.colors.gray.light} solid;
      .rc-tabs-tab {
        width: 100%;
        display: flex;
        justify-content: center;
        font-size: 0.938rem;
        padding-bottom: 1rem;
      }
      .rc-tabs-tab-active {
        font-weight: bold;
      }
      .rc-tabs-ink-bar {
        position: absolute;
        pointer-events: none;
        height: 3px;
        bottom: 0px;
        background: ${(theme) => theme.colors.primary};
      }
      .rc-tabs-ink-bar-animated {
        transition: all 0.3s;
      }
    }
  }
`;
exports.Tab = rc_tabs_1.TabPane;
exports.Tabs = (0, react_1.forwardRef)((_a, ref) => {
    var { children, keepInactiveTabPane } = _a, rest = __rest(_a, ["children", "keepInactiveTabPane"]);
    const [activeTab, setTab] = (0, react_1.useState)();
    const childrenArray = (0, toArray_1.default)(children);
    const tabsContextValue = (0, react_1.useCallback)((child) => ({
        setTab,
        activeTab,
        tab: String(child.key) || undefined,
    }), [activeTab]);
    const insideForm = Boolean((0, react_1.useContext)(lib_1.InternalFormContext));
    const forceRender = insideForm && (keepInactiveTabPane !== null && keepInactiveTabPane !== void 0 ? keepInactiveTabPane : true);
    const destroyInactiveTabPane = !(keepInactiveTabPane !== null && keepInactiveTabPane !== void 0 ? keepInactiveTabPane : insideForm);
    return ((0, jsx_runtime_1.jsx)(StyledTabs, Object.assign({ ref: ref, onTabClick: setTab, destroyInactiveTabPane: !keepInactiveTabPane, tabPosition: "top" }, (0, utils_1.exclude)({ activeKey: activeTab }, undefined), rest, { children: childrenArray.map((child) => (0, react_1.cloneElement)(child, { tab: child.props.label, destroyInactiveTabPane, forceRender }, (0, jsx_runtime_1.jsx)(exports.TabsContext.Provider, Object.assign({ value: tabsContextValue(child) }, { children: child.props.children })))) })));
});
